import "./i18n"
import "url:./styles/global.scss"

import React from "react"
import { createRoot } from "react-dom/client"
import * as serviceWorker from "./service-worker"
import { App } from "./app"
import { zxcvbnOptions } from "@zxcvbn-ts/core"
import zxcvbnCommonPackage from "@zxcvbn-ts/language-common"
import zxcvbnEnPackage from "@zxcvbn-ts/language-en"
import zxcvbnDePackage from "@zxcvbn-ts/language-de"
import { OptionsType } from "@zxcvbn-ts/core/dist/types"
import i18n from "./i18n"

function setupZxcvbn() {
    const translations = (
        i18n.language.startsWith("de") ? zxcvbnDePackage : zxcvbnEnPackage
    ).translations
    const options: OptionsType = {
        translations,
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
            ...zxcvbnEnPackage.dictionary,
        },
    }

    zxcvbnOptions.setOptions(options)
}

setupZxcvbn()

const container = document.getElementById("app")
if (container) {
    const root = createRoot(container)
    root.render(<App />)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
